import { useSourceList } from "./useSourceList";

/**
 * Fetches the list of items inside a folder (only for folder nodes).
 * Use when a folder is expanded; triggers tars/source/list with parent_id = folderId.
 */
export function useFolderContents(
  notebookId: number | null,
  folderId: string | null,
  enabled: boolean
) {
  const folderIdNum =
    folderId != null && folderId !== "" ? Number(folderId) : null;
  const isValidFolder =
    folderIdNum != null && !Number.isNaN(folderIdNum) && notebookId != null;

  const params =
    enabled && isValidFolder && notebookId != null && folderIdNum != null
      ? {
          notebook_id: notebookId,
          parent_id: folderIdNum as number,
          offset: 0,
          limit: 20,
        }
      : null;

  return useSourceList(params);
}
